module.exports = __webpack_public_path__ + "resources/img/img_dsm2_m_jp.0efec30964240f8e83768c4f8f9c99c8.png";